import { put, call, takeEvery } from "redux-saga/effects";
import request from "utils/api";
import _pick from "lodash/pick";
import { safe } from "providers/GeneralProvider/saga";
import {
  getSystemNotificationListRequest,
  getSystemNotificationListSuccess,
  createSystemNotificationRequest,
  createSystemNotificationSuccess,
  getSystemNotificationDetailRequest,
  getSystemNotificationDetailSuccess,
  updateSystemNotificationRequest,
  updateSystemNotificationSuccess,
  deleteAllSystemNotificationsRequest,
  deleteAllSystemNotificationsSuccess,
  retrySystemNotificationRequest,
  retrySystemNotificationSuccess,
  stopLoading,
} from "./slice";

function* getSystemNotificationList(action) {
  try {
    const params = _pick(action.payload, [
      "page",
      "limit",
    ]);

    // Set default values if not provided
    if (!params.page) params.page = 1;
    if (!params.limit) params.limit = 20;

    const { data } = yield call(
      request,
      "api/fonehouse/notification-manager/system-notification/list",
      params,
      {
        method: "GET",
      }
    );

    console.log("API response data:", data);
    yield put(getSystemNotificationListSuccess(data));
  } catch (error) {
    yield put(stopLoading());
  }
}

function* createSystemNotification(action) {
  try {
    const notificationData = action.payload;
    const { meta } = action;

    const data = yield call(
      request,
      "api/fonehouse/notification-manager/system-notification/create",
      notificationData,
      {
        method: "POST",
      }
    );

    yield put(createSystemNotificationSuccess(data, meta));
  } catch (error) {
    yield put(stopLoading());
    throw error; // Re-throw the error so the component can catch it
  }
}

function* getSystemNotificationDetail(action) {
  try {
    const notificationId = action.payload;
    const { meta } = action;

    const { data } = yield call(
      request,
      `api/fonehouse/notification-manager/system-notification/detail/${notificationId}`,
      {},
      {
        method: "GET",
      }
    );

    console.log("Notification detail API response:", data);
    yield put(getSystemNotificationDetailSuccess(data?.notification || data, meta));
  } catch (error) {
    console.error("Error fetching notification detail:", error);
    yield put(stopLoading());
  }
}

function* updateSystemNotification(action) {
  try {
    const { notificationId, notificationData } = action.payload;
    const { meta } = action;

    const data = yield call(
      request,
      `api/fonehouse/notification-manager/system-notification/update/${notificationId}`,
      notificationData,
      {
        method: "PUT",
      }
    );

    yield put(updateSystemNotificationSuccess(data, meta));
  } catch (error) {
    console.error("Error updating notification:", error);
    yield put(stopLoading());
    throw error; // Re-throw the error so the component can catch it
  }
}

function* deleteAllSystemNotifications(action) {
  try {
    const { meta } = action;

    const { data } = yield call(
      request,
      "api/fonehouse/notification-manager/system-notification/delete-all",
      {},
      {
        method: "DELETE",
      }
    );

    console.log("Delete all notifications response:", data);
    yield put(deleteAllSystemNotificationsSuccess(data, meta));
  } catch (error) {
    console.error("Error deleting all notifications:", error);
    yield put(stopLoading());
    throw error;
  }
}

function* retrySystemNotification(action) {
  try {
    const notificationId = action.payload;
    const { meta } = action;

    const { data } = yield call(
      request,
      `api/fonehouse/notification-manager/system-notification/${notificationId}/retry`,
      {},
      {
        method: "POST",
      }
    );

    yield put(retrySystemNotificationSuccess(data, meta));
  } catch (error) {
    yield put(stopLoading());
    throw error;
  }
}

function onError(error) {
  console.error("System Notification Error:", error);
}

export default function* watchSystemNotification() {
  yield takeEvery(
    getSystemNotificationListRequest.type,
    safe(getSystemNotificationList, onError)
  );
  yield takeEvery(
    createSystemNotificationRequest.type,
    safe(createSystemNotification, onError)
  );
  yield takeEvery(
    getSystemNotificationDetailRequest.type,
    safe(getSystemNotificationDetail, onError)
  );
  yield takeEvery(
    updateSystemNotificationRequest.type,
    safe(updateSystemNotification, onError)
  );
  yield takeEvery(
    deleteAllSystemNotificationsRequest.type,
    safe(deleteAllSystemNotifications, onError)
  );
  yield takeEvery(
    retrySystemNotificationRequest.type,
    safe(retrySystemNotification, onError)
  );
} 